import React, { useState } from "react";
import moment from "jalali-moment";

import Modal from "../../../../shared/modal";
const CommetDetails = ({ email, comment, date }) => {
  const [showCommentModal, setShowCommentModal] = useState(false);

  const showAddressHandler = () => {
    setShowCommentModal(true);
  };

  const closeHandler = () => {
    setShowCommentModal(false);
  };

  return (
    <div
      style={{ direction: "rtl" }}
      className="font-IRANSansWeb  flex
      border-2 my-2 mx-2 font-bold border-gray-400  rounded-lg py-2 text-[12px] gap-x-4
      caret-transparent screen800:text-[10px] screen400:text-[8px] screen600:grid-cols-2"
    >
      <div className="pt-2 px-1  w-[30%]  overflow-ellipsis whitespace-nowrap overflow-hidden hover:overflow-visible screen700:text-right">
        {email}
      </div>
      <div className="pt-2 screen400:text-[7px]  w-[10%]">
        {moment(date, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD")}
      </div>

      <div
        onClick={showAddressHandler}
        className={`pt-2 pl-1 overflow-ellipsis whitespace-nowrap overflow-hidden hover:cursor-text  w-[50%] screen700:text-left`}
      >
        {comment}
      </div>
      <div className=" fixed top-[200px] left-[33%] screen600:left-[25%] screen500:left-[22%]  ">
        {showCommentModal && (
          <Modal body={comment} closeHandler={closeHandler} />
        )}
      </div>
    </div>
  );
};
export default CommetDetails;
